//#region src/bite_log_worldpay_event.ts
var BiteLogWorldpayEvent = /* @__PURE__ */ function(BiteLogWorldpayEvent) {
	BiteLogWorldpayEvent[BiteLogWorldpayEvent["TerminalDisconnected"] = 1] = "TerminalDisconnected";
	BiteLogWorldpayEvent[BiteLogWorldpayEvent["UpdateIdleTextError"] = 2] = "UpdateIdleTextError";
	BiteLogWorldpayEvent[BiteLogWorldpayEvent["TerminalRebootRequestSuccess"] = 3] = "TerminalRebootRequestSuccess";
	BiteLogWorldpayEvent[BiteLogWorldpayEvent["TerminalRebootRequestError"] = 4] = "TerminalRebootRequestError";
	BiteLogWorldpayEvent[BiteLogWorldpayEvent["TerminalIdleTextRequestSuccess"] = 5] = "TerminalIdleTextRequestSuccess";
	BiteLogWorldpayEvent[BiteLogWorldpayEvent["TerminalIdleTextRequestError"] = 6] = "TerminalIdleTextRequestError";
	return BiteLogWorldpayEvent;
}(BiteLogWorldpayEvent || {});
//#endregion
export { BiteLogWorldpayEvent };

//# sourceMappingURL=bite_log_worldpay_event.js.map